import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=01736abd&scoped=true"
import script from "./Bonus.vue?vue&type=script&lang=ts"
export * from "./Bonus.vue?vue&type=script&lang=ts"
import style0 from "./Bonus.vue?vue&type=style&index=0&id=01736abd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01736abd",
  null
  
)

export default component.exports